
import baiduAd from "../utils/baidu";
function render(adData, el) {
    let { tuid, isTemplet='' }=adData;
    const bottomDiv = document.createElement("div");
    const adHeight =130;
    bottomDiv.style.cssText =`
    display: block;
    width: 1000px;
    margin: 0 auto;
    transition: all 0.3s;
    height: ${adHeight}px !important;
    bottom: -${adHeight}px;
    clear: none !important;
    float: none !important;
    left: 50%;
    transform: translateX(-50%);
    max-height: none !important;
    max-width: none !important;
    opacity: 1;
    overflow: visible !important;
    padding: 0px !important;
    position: fixed;
    right: auto !important;
    top: auto !important;
    vertical-align: baseline !important;
    visibility: visible !important;
    z-index: 2147483643;
    box-shadow: rgba(0, 0, 0, 0.5) 0px -4px 12px -4px, rgba(0, 0, 0, 0.3) 0px 4px 8px -3px;
    border-radius: 5px;
    background: rgb(250, 250, 250) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    `
    bottomDiv.innerHTML = `<span style="cursor: pointer; width: 80px !important; height: 45px !important; top: -40px !important; left: 20% !important; pointer-events: none !important; position: absolute !important;display:none;"><svg style="margin: 0px !important; position: absolute !important; bottom: 0px !important; left: 0% !important; display: block !important; width: 80px !important; height: 30px !important; transform: none !important; pointer-events: initial !important;"><defs><filter id="dropShadowTop" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feComponentTransfer in="SourceAlpha" result="TransferredAlpha"><feFuncR type="discrete" tableValues="0.5"></feFuncR><feFuncG type="discrete" tableValues="0.5"></feFuncG><feFuncB type="discrete" tableValues="0.5"></feFuncB></feComponentTransfer><feGaussianBlur in="TransferredAlpha" stdDeviation="2"></feGaussianBlur><feOffset dx="0" dy="0" result="offsetblur"></feOffset><feMerge><feMergeNode></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter></defs><path d="M10,26 L10,6 A6,6 0 0,1 16,1 L60,1 A6,6 0 0,1 66,6 L66,20 66,26 Z" stroke="#FAFAFA" stroke-width="1" fill="#FAFAFA" style="filter: url(&quot;#dropShadowTop&quot;);"></path><rect x="0" y="25" width="80" height="5" style="fill: rgb(250, 250, 250);"></rect><g class="down" stroke="#616161" stroke-width="2px" stroke-linecap="square"><line x1="32" y1="12" x2="38" y2="18"></line><line x1="38" y1="18" x2="44" y2="12"></line></g></svg></span>`;
    const adContent = document.createElement("div");
    bottomDiv.appendChild(adContent);
    adContent.style.cssText = `
    width: 1400px;
    height: 126px;
    `;
    bottomDiv.firstChild.onclick=function(){
        bottomDiv.style.bottom = - 2 * adHeight + "px";
        document.body.style.marginBottom = "0px";
        window.IfengAmgr.eventEmitter && window.IfengAmgr.eventEmitter.emit('windowAdBottomClose', 130);
        window.IfengAmgr.eventEmitter && window.IfengAmgr.eventEmitter.emit('windowAdClose');
    }
    bottomDiv.style.display = "none";
    baiduAd({
        tuid,//百度 tuid
        w:1400,//宽
        h:140, //高
        rem: false,
        closeFn: function () {
            bottomDiv.firstChild.click();
        },
        visibleRender: false,
        renderOk: function (div) {
            //如果外部不发曝光
            bottomDiv.style.display = "flex";
          
        }
    }, adContent);
    window.addEventListener("message", (e) => {
        let data = e.data;
        console.log(data);
        if (data) {
            if(typeof data == 'string'){
                data = JSON.parse(data)
            }
            if (data.tuid && data.tuid.split("_")[0] == tuid && data.msg =="ok"){
                document.body.style.marginBottom = adHeight + "px";
                bottomDiv.style.bottom = "0px";
                window.IfengAmgr.eventEmitter && window.IfengAmgr.eventEmitter.emit('windowAdBottomOpen',130);
                setTimeout(()=>{
                    window.IfengAmgr.eventEmitter && window.IfengAmgr.eventEmitter.emit('windowAdOpen');
                },1000)
                if (isTemplet == "on") {
                    if (imp_arr) {
                        SendUrls(imp_arr);
                    }
                }
            }
        }
    })
    document.body.appendChild(bottomDiv);
    
}
if (typeof window.IfengAmgr != undefined) {
    window.IfengAmgr.tplLib.pc_bottom = { render: render, version: "1.0.0" };
}
